import React, { useState } from 'react';
import { Box, Typography, styled, Grid, Dialog, DialogContent, DialogTitle, useMediaQuery, useTheme } from '@mui/material';
import { useGetCurrentUserQuery } from 'src/redux/services/users';
import ButtonComponent from 'src/components/ButtonComponent';
import ConsumptionGraphs from 'src/pages/Welcome/components/ConsumptionGraphs';
import CloseIcon from '@mui/icons-material/Close';
import DateFilter from 'src/components/DateFilter';
import QueryValuesLayout from 'src/components/Layouts/QueryValuesLayout';
import { DateRange } from 'src/utils/date';
import FirstThreeCards from 'src/pages/Welcome/components/FirstThreeCards';
import LastThreeCards from 'src/pages/Welcome/components/LastThreeCards';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';

const ContentWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  '& p': {
    color: theme.palette.text.secondary,
  },
}));

export interface Props {
  dateRange: DateRange;
  setDateRange: (d: DateRange) => void;
}

// eslint-disable-next-line complexity
export const InnerWelcomePage: React.FC<Props> = ({ dateRange, setDateRange }) => {
  const [sumOfCost, setSumOfCost] = useState<number | null>(null);
  const [modalIsOpen, setModalIsOpen] = React.useState<boolean>(false);
  const { data: currentUser } = useGetCurrentUserQuery();

  const isUserAdmin = currentUser?.item?.roles?.includes('ROLE_ADMIN') ?? false;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMdView = useMediaQuery('(max-width: 1920px)');

  return (
    <DashboardPageLayout>
      <ContentWrapper>
        <Grid
          container
          justifyContent="space-between"
          style={{
            padding: theme.spacing(3, 0, 1),
          }}
        >
          <Grid item xs={12} md={6}>
            {currentUser && <Typography variant="h2">{`Hello, ${currentUser.item.first_name}!`}</Typography>}
          </Grid>
          <Grid item xs={12} md={6}>
            <DateFilter
              dateRange={dateRange}
              setDateRange={(range) => {
                setDateRange(range);
              }}
            />
          </Grid>
        </Grid>
        <FirstThreeCards sumOfCost={sumOfCost} />
        <ConsumptionGraphs dateRange={dateRange} setSumOfCost={setSumOfCost} />
        <LastThreeCards setModalIsOpen={setModalIsOpen} isUserAdmin={isUserAdmin} />
      </ContentWrapper>
      <Dialog fullWidth={true} maxWidth={isMobile ? 'xs' : isMdView ? 'md' : 'lg'} open={modalIsOpen}>
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h4" data-testid="request-a-demo-modal-title">
              Request a demo
            </Typography>
            <ButtonComponent data-testid="request-close-modal" buttontype="icon" icon={<CloseIcon />} onClick={() => setModalIsOpen(false)} />
          </Grid>
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden', padding: 0 }}>
          <iframe
            src="https://meetings.hubspot.com/paolo-mardegan/book-a-demo?embed=true"
            style={{
              width: '100%',
              height: '90vh',
              maxHeight: 800,
              border: 0,
            }}
          />
        </DialogContent>
      </Dialog>
    </DashboardPageLayout>
  );
};

const WelcomePage: React.FC = () => (
  <QueryValuesLayout>{({ dateRange, setDateRange }) => <InnerWelcomePage dateRange={dateRange} setDateRange={setDateRange} />}</QueryValuesLayout>
);

export default WelcomePage;
